import type {SearchCriteriaRaw} from '../../../types';
import {createVisualRule} from '../visualRule';
import type {VisualRule, TSearchTypeVisual} from '../types';

export type RawVisualSearchCriteria = SearchCriteriaRaw<TSearchTypeVisual>;

export const rawVisualCriteriaToRuleObject = (
	criteria: RawVisualSearchCriteria,
): VisualRule<any> => {
	return createVisualRule({
		type: criteria.subtype1,
		color: criteria.value1,
		assetId: parseInt(criteria.value1) || 0,
	} as any) as VisualRule<any>;
};

export default rawVisualCriteriaToRuleObject;
